export const accordion = () => {
	$(function () {
		$(".accordion dt").click(function () {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});
	});

	$(function () {

		$('#sitemap_open').click(function () {

			var footer = $('.footer_navi').offset().top;
			var position = footer + 500;

			$("html, body").animate({ scrollTop: position }, { queue: false }, 1000);
		});
	});

};